// projects/humanresources-payroll/src/assets/i18n/*/hr-pay-common-pay.json
export class HrPayCommonPayKey {
    private static readonly keyPrefix = 'hrPayCommonPay';
    public static active = `${HrPayCommonPayKey.keyPrefix}.active`;
    public static blockage = `${HrPayCommonPayKey.keyPrefix}.blockage`;
    public static payWageGroup = `${HrPayCommonPayKey.keyPrefix}.payWageGroup`;
    public static pageHeader = `${HrPayCommonPayKey.keyPrefix}.pageHeader`;
    public static additionalFields = `${HrPayCommonPayKey.keyPrefix}.additionalFields`;
    public static additionalFieldDescription = `${HrPayCommonPayKey.keyPrefix}.additionalFieldDescription`;
    public static emptyStateMainTitle = `${HrPayCommonPayKey.keyPrefix}.emptyStateMainTitle`;
    public static emptyStateSubtitle = `${HrPayCommonPayKey.keyPrefix}.emptyStateSubtitle`;
}
